import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { Button } from "../Form";
import {
  FaArrowRight,
  FaArrowLeft,
  FaSave,
  FaTimesCircle,
  FaTrashAlt
} from "react-icons/fa";
import toast from "react-hot-toast";
import { updateVisitasById } from "../../redux/features/visitasSlice";
import ConfirmationAlert from "../ConfirmationAlert";
import { isUndefined } from "lodash";
import { useViewType } from "../../utils/ViewState";
import FullBodyPainter from "../Drawer/FullBodyPainter";

export const DivCorporal = ({ visita, setVisita, functions, visible = true }) => {
  const [basePoints, setBasePoints] = useState({ front: [], back: [] });
  const [draftPoints, setDraftPoints] = useState({ front: [], back: [] });
  const [fullPoints, setFullPoints] = useState([]);
  const [pendingPoint, setPendingPoint] = useState(null);

  const [isBack, setIsBack] = useState(false);
  // const isFemn = visita?.patient?.persona.sexo === "Femenino";
  const [openSubModal, setOpenSubModal] = useState(false);
  const [selectPart, setSelectPart] = useState(null);
  const [sizeImage, setSizeImage] = useState({ width: 0, height: 0 });
  const [url, setUrl] = useState("");
  const view = useViewType();

  let bodyParts = {};
  if (isBack) {
    if (view) {
      bodyParts = {
        CABEZA: {
          left: "41%",
          top: "6%",
          width: "20%",
          height: "14%",
        },
        TORSO: {
          left: "35%",
          top: "20%",
          width: "33%",
          height: "25%",
        },
        BRAZO_DER: {
          left: "68%",
          top: "20%",
          width: "26%",
          height: "27%",
        },
        BRAZO_IZQ: {
          left: "9%",
          top: "20%",
          width: "26%",
          height: "27%",
        },
        MANO_DER: {
          left: "68%",
          top: "47%",
          width: "26%",
          height: "10%",
        },
        MANO_IZQ: {
          left: "9%",
          top: "47%",
          width: "26%",
          height: "10%",
        },
        PIERNA_DER: {
          left: "53%",
          top: "45%",
          width: "15%",
          height: "40%",
        },
        PIERNA_IZQ: {
          left: "35%",
          top: "45%",
          width: "18%",
          height: "40%",
        },
        PIE_DER: {
          left: "53%",
          top: "85%",
          width: "15%",
          height: "9%",
        },
        PIE_IZQ: {
          left: "35%",
          top: "85%",
          width: "18%",
          height: "9%",
        },
      };
    } else {
      bodyParts = {
        CABEZA: {
          left: "40%",
          top: "7%",
          width: "20%",
          height: "14%",
        },
        TORSO: {
          left: "32%",
          top: "21%",
          width: "35%",
          height: "25%",
        },
        BRAZO_IZQ: {
          left: "67%",
          top: "21%",
          width: "26%",
          height: "26%",
        },
        BRAZO_DER: {
          left: "6%",
          top: "21%",
          width: "26%",
          height: "26%",
        },
        MANO_IZQ: {
          left: "67%",
          top: "47%",
          width: "26%",
          height: "10%",
        },
        MANO_DER: {
          left: "6%",
          top: "47%",
          width: "26%",
          height: "10%",
        },
        PIERNA_IZQ: {
          left: "50%",
          top: "46%",
          width: "17%",
          height: "40%",
        },
        PIERNA_DER: {
          left: "32%",
          top: "46%",
          width: "17%",
          height: "40%",
        },
        PIE_IZQ: {
          left: "50%",
          top: "86%",
          width: "17%",
          height: "9%",
        },
        PIE_DER: {
          left: "32%",
          top: "86%",
          width: "17%",
          height: "9%",
        },
      };
    }
  } else {
    if (view) {
      bodyParts = {
        CABEZA: {
          left: "40%",
          top: "7%",
          width: "20%",
          height: "14%",
        },
        TORSO: {
          left: "32%",
          top: "21%",
          width: "35%",
          height: "25%",
        },
        BRAZO_IZQ: {
          left: "67%",
          top: "21%",
          width: "26%",
          height: "26%",
        },
        BRAZO_DER: {
          left: "6%",
          top: "21%",
          width: "26%",
          height: "26%",
        },
        MANO_IZQ: {
          left: "67%",
          top: "47%",
          width: "26%",
          height: "10%",
        },
        MANO_DER: {
          left: "6%",
          top: "47%",
          width: "26%",
          height: "10%",
        },
        PIERNA_IZQ: {
          left: "50%",
          top: "46%",
          width: "17%",
          height: "40%",
        },
        PIERNA_DER: {
          left: "32%",
          top: "46%",
          width: "17%",
          height: "40%",
        },
        PIE_IZQ: {
          left: "50%",
          top: "86%",
          width: "17%",
          height: "9%",
        },
        PIE_DER: {
          left: "32%",
          top: "86%",
          width: "17%",
          height: "9%",
        },
      };
    } else {
      bodyParts = {
        CABEZA: {
          left: "40%",
          top: "7%",
          width: "20%",
          height: "14%",
        },
        TORSO: {
          left: "32%",
          top: "21%",
          width: "35%",
          height: "25%",
        },
        BRAZO_IZQ: {
          left: "67%",
          top: "21%",
          width: "26%",
          height: "26%",
        },
        BRAZO_DER: {
          left: "6%",
          top: "21%",
          width: "26%",
          height: "26%",
        },
        MANO_IZQ: {
          left: "67%",
          top: "47%",
          width: "26%",
          height: "10%",
        },
        MANO_DER: {
          left: "6%",
          top: "47%",
          width: "26%",
          height: "10%",
        },
        PIERNA_IZQ: {
          left: "50%",
          top: "46%",
          width: "17%",
          height: "40%",
        },
        PIERNA_DER: {
          left: "32%",
          top: "46%",
          width: "17%",
          height: "40%",
        },
        PIE_IZQ: {
          left: "50%",
          top: "86%",
          width: "17%",
          height: "9%",
        },
        PIE_DER: {
          left: "32%",
          top: "86%",
          width: "17%",
          height: "9%",
        },
      };
    }
  }

  useEffect(() => {
    const newUrl = isBack
    ? ("/images/imageCorporalMBack.jpg")
    : ("/images/imageCorporalMFront.JPG");
    // const newUrl = isBack
    // ? (isFemn ? "/images/imageCorporalFBack.jpg" : "/images/imageCorporalMBack.jpg")
    // : (isFemn ? "/images/imageCorporalFFront.jpg" : "/images/imageCorporalMFront.JPG");
    
    setUrl(newUrl);

    const img = new Image();
    img.src = newUrl;

    img.onload = () => {
      setSizeImage({
        width: img.width / 3,
        height: img.height / 6,
      });
    };
  }, [isBack]);

  useEffect(() => {
    const cuerpoBackend =
    typeof visita.cuerpo === "string"
    ? JSON.parse(visita.cuerpo)
    : visita.cuerpo || {};
    
    const flat = (sideData) => Object.entries(sideData || {}).flatMap(([partKey, val]) => {
      const arr = Array.isArray(val?.puntos) ? val.puntos : [];
      return arr.map((p, idx) => ({
        id: p.id || `${partKey}_${idx}`,
        part: partKey,
        xPct: typeof p.xPct === "number" ? p.xPct : (typeof p.x === "number" ? p.x : 0),
        yPct: typeof p.yPct === "number" ? p.yPct : (typeof p.y === "number" ? p.y : 0),
        sizePct: typeof p.sizePct === "number" ? p.sizePct : (typeof p.diametro === "number" ? p.diametro : 0.02),
        color: p.color || "#FF0000",
        diagnostico: p.diagnostico || "",
      }));
    });
    setBasePoints({
      front: flat(cuerpoBackend.front),
      back: flat(cuerpoBackend.back)
    })
  }, [visita]);

  const handlePointCreated = ({id, part, xPct, yPct, sizePct, color, diagnostico}) => {
    setDraftPoints(prev => ({
      ...prev,
      [isBack ? "back" : "front"]: [...prev[isBack ? "back" : "front"] || [], {id, part, xPct, yPct, sizePct, color, diagnostico}]
    }))
    setFullPoints(prev => [...prev, { id, part, xPct, yPct, sizePct, color, diagnostico }]);
    setSelectPart(part);
    setPendingPoint({ id, xPct, yPct, sizePct, color });
    // setOpenSubModal(true);
    setSelectPart(part);
  };

  const handleDeleteDraft = (point) => {
    const side = isBack ? "back" : "front";
    setDraftPoints(prev => ({
      ...prev,
      [side]: (prev[side] || []).filter(p => p.id !== point.id),
    }));
  };

  const handleOpenDiagnostico = (point) => {
    setSelectPart(point.part);
    setPendingPoint(point);
    setOpenSubModal(true);
  };

  const closeModal = () => {
    setPendingPoint({});
    setOpenSubModal(false);
  }

  const sideKey = isBack ? "back" : "front";
  const mergedPoints = [...(basePoints[sideKey] || []), ...(draftPoints[sideKey] || [])];

  const updateSavedPoint = (side, part, pointId, updates) => {
    setBasePoints(prev => ({
      ...prev,
      [side]: (prev[side] || []).map(p => {
        if (p.part === part && p.id === pointId) {
          return { ...p, ...updates };
        }
        return p;
      })
    }));
  };

  const removeSavedPoint = (side, part, pointId) => {
    setBasePoints(prev => ({
      ...prev,
      [side]: (prev[side] || []).filter(p => !(p.part === part && p.id === pointId))
    }));
  };

const applySavedPoints = (side, part, draftsOfThisPart) => {
  setBasePoints(prev => ({
    ...prev,
    [side]: [
      ...(prev[side] || []),
      ...draftsOfThisPart.map(p => ({
        id: p.id,
        part,
        xPct: p.xPct,
        yPct: p.yPct,
        sizePct: p.sizePct,
        color: p.color,
        diagnostico: p.diagnostico,
      })),
    ],
  }));
  // limpia borradores de ese part/side
  setDraftPoints(prev => ({
    ...prev,
    [side]: (prev[side] || []).filter(dp => !draftsOfThisPart.some(pp => pp.id === dp.id)),
    // [side]: (prev[side] || []).filter(dp => dp.part !== part),
  }));
};

  return (
    <div width={"w-full"}>
      <div>
      <div className="flex justify-center">
        <FullBodyPainter
          key={`${url}-${isBack ? 'back' : 'front'}-${visible ? 'on' : 'off'}`}
          imgSrc={url}
          bodyParts={bodyParts}
          points={mergedPoints}
          onPointCreated={handlePointCreated}
          onDeleteDraft={handleDeleteDraft}
          onOpenDiagnostico={handleOpenDiagnostico}
          showDebug={true}
          visible={visible}
        />
      </div>
      <Button
        label={!isBack ? "Atrás" : "Frontal"}
        onClick={() => setIsBack(!isBack)}
        Icon={!isBack ? FaArrowRight : FaArrowLeft}
      />
      </div>
      {openSubModal && (
        <ModalPartOfBody
          isOpen={openSubModal}
          closeModal={() => closeModal()}
          isBack={isBack}
          // isFemn={isFemn}
          part={selectPart}
          visita={visita}
          setVisita={setVisita}
          functions={functions}
          pendingPoint={pendingPoint}
          draftPoints={draftPoints}
          setDraftPoints={setDraftPoints}
          onDeleteDraft={handleDeleteDraft}
          view={view}
          applySavedPoints={applySavedPoints}
          updateSavedPoint={updateSavedPoint}
          removeSavedPoint={removeSavedPoint}
        />
      )}
    </div>
  );
};

export const CorporalModal = ({
  visita,
  setVisita,
  closeModal,
  isOpen,
  title,
  functions,
}) => {
  return (
    <Modal closeModal={closeModal} isOpen={isOpen} title={title}>
      <DivCorporal visita={visita} setVisita={setVisita} functions={functions} />
    </Modal>
  );
};

const ModalPartOfBody = ({
  closeModal,
  isOpen,
  part,
  visita,
  setVisita,
  isBack,
  // isFemn,
  functions,
  pendingPoint,
  onDeleteDraft,
  draftPoints,
  setDraftPoints,
  view,
  applySavedPoints,
  updateSavedPoint,
  removeSavedPoint,
}) => {
  const [title, setTitle] = useState("");
  const [path, setPath] = useState("");
  const [FrontBackBody, setFrontBackBody] = useState({});
  const [areaAfectada, setAreaAfectada] = useState("");
  const [diagnostico, setDiagnostico] = useState("");
  const [drawnPoints, setDrawnPoints] = useState([]);
  const [code, setCode] = useState("C001");

  const sideKey = isBack ? "back" : "front";
  const [isEdit, setIsEdit] = useState(false);
  const [originalPointKey, setOriginalPointKey] = useState(null);

  const validParts = [
    "CABEZA",
    "TORSO",
    "BRAZO_IZQUIERDO",
    "BRAZO_DERECHO",
    "PIERNA_IZQUIERDA",
    "PIERNA_DERECHA",
  ];
  const subParts = [
    { id: 1, name: "Ninguno" },
    { id: 2, name: isBack ? "Palma" : "Frontal" },
    { id: 3, name: "Pulgar" },
    { id: 4, name: "Indice" },
    { id: 5, name: "Medio" },
    { id: 6, name: "Anular" },
    { id: 7, name: "Meñique" },
  ];

  useEffect(() => {
    const cuerpoBackend =
      typeof visita.cuerpo === "string"
        ? JSON.parse(visita.cuerpo)
        : visita.cuerpo || {};
    const sideData = cuerpoBackend[isBack ? "back" : "front"] || {};
    setFrontBackBody(sideData);

    const partData = sideData[part];

    if (partData) {
      setAreaAfectada(partData.area_afectada || "");
      // setDiagnostico(partData.diagnostico || "");

      if (Array.isArray(partData.puntos) && partData.puntos.length > 0) {
        setDrawnPoints(
          partData.puntos.map((p) => ({
            x: p.x,
            y: p.y,
            size: p.diametro,
            color: p.color,
          }))
        );
      } else {
        setDrawnPoints([]);
      }
    } else {
      setAreaAfectada("");
      setDiagnostico("");
      setDrawnPoints([]);
    }

    let editing = false;
    let storageKey = null;

    if (partData && Array.isArray(partData.puntos)) {
      const idx = partData.puntos.findIndex((pp, i) => {
        const pid = pp.id || `${part}_${i}`;
        const sameId = pendingPoint?.id && pid === pendingPoint.id;

        // fallback por coords si no hay id persistido
        const sameCoords = typeof pp.x === "number" && typeof pp.y === "number"
          && Math.abs((pendingPoint?.xPct ?? -999) - pp.x) < 1e-9
          && Math.abs((pendingPoint?.yPct ?? -999) - pp.y) < 1e-9;

        return sameId || sameCoords;
      });

      if (idx >= 0) {
        editing = true;
        const pp = partData.puntos[idx];
        setDiagnostico(pp.diagnostico || "");
        storageKey = pp.id || `${part}_${idx}`;
      }
    }

    setIsEdit(editing);
    setOriginalPointKey(storageKey);

    let nextCode = code;
    if (Object.keys(cuerpoBackend).length > 0) {
      const parts = Object.values(cuerpoBackend).flatMap((part) =>
        Object.values(part).flatMap((subPart) => {
          if (subPart.code) {
            return subPart.code;
          }
          return [];
        })
      );
      const lastCode = parts.sort()[parts.length - 1];
      if (!isUndefined(lastCode) && lastCode !== "") {
        const prefix = lastCode.slice(0, 1); // "C"
        const number = parseInt(lastCode.slice(1), 10); // 10
        const nextNumber = number + 1; // 11
        nextCode = prefix + String(nextNumber).padStart(3, "0");
      }
    }
    setCode(nextCode);

    setupPathAndTitle();
  }, [part, visita, isBack]);

  const setupPathAndTitle = () => {
    switch (part) {
      case "CABEZA":
        if (isBack) {
          setPath("");
          setTitle("Diagnostico Cabeza y region cervical");
          setAreaAfectada("Cabeza y region cervical");
        } else {
          setTitle("Diagnostico Cabeza y region cervical anterior");
          setAreaAfectada("Cabeza y region cervical anterior");
          setPath(
            "/images/imageCMFFace.jpg"
          );
        }
        break;
      case "TORSO":
        if (isBack) {
          setTitle("Diagnostico Cintura escapular y region dorsal superior");
          setAreaAfectada("Cintura escapular y region dorsal superior");
          setPath(
            "/images/imageCMBBreast.jpg"
          );
        } else {
          setTitle("Diagnostico Torax (region pectoral y esternal)");
          setAreaAfectada("Torax (region pectoral y esternal)");
          setPath(
            "/images/imageCMFBreast.jpg"
          );
        }
        break;
      case "BRAZO_IZQ":
        setTitle("Diagnostico Brazo Izquierdo");
        setAreaAfectada("Brazo Izquierdo");
        if (isBack) {
          setPath(
            "/images/imageCMBArmLeft.jpg"
          );
        } else {
          setPath(
            "/images/imageCMFArmLeft.jpg"
          );
        }
        break;
      case "BRAZO_DER":
        setTitle("Diagnostico Brazo Derecho");
        setAreaAfectada("Brazo Derecho");
        if (isBack) {
          setPath(
            "/images/imageCMBArmRight.jpg"
          );
        } else {
          setPath(
            "/images/imageCMFArmRight.jpg"
          );
        }
        break;
      case "MANO_IZQ":
        if (isBack) {
          setTitle("Diagnostico Palma Izquierda");
          setAreaAfectada("Palma Izquierda");
          setPath(
            "/images/imageCMBHandLeft.jpg"
          );
        } else {
          setTitle("Diagnostico Mano Izquierda");
          setAreaAfectada("Mano Izquierda");
          setPath(
            "/images/imageCMFHandLeft.jpg"
          );
        }
        break;
      case "MANO_DER":
        if (isBack) {
          setTitle("Diagnostico Palma Derecha");
          setAreaAfectada("Palma Derecha");
          setPath(
            "/images/imageCMBHandRight.jpg"
          );
        } else {
          setTitle("Diagnostico Mano Derecha");
          setAreaAfectada("Mano Derecha");
          setPath(
            "/images/imageCMFHandRight.jpg"
          );
        }
        break;
      case "PIERNA_IZQ":
        setTitle("Diagnostico Pierna Izquierda");
        setAreaAfectada("Pierna Izquierda");
        if (isBack) {
          setPath(
            "/images/imageCMBLegLeft.png"
          );
        } else {
          setPath(
            "/images/imageCMFLegLeft.png"
          );
        }
        break;
      case "PIERNA_DER":
        setTitle("Diagnostico Pierna Derecha");
        setAreaAfectada("Pierna Derecha");
        if (isBack) {
          setPath(
            "/images/imageCMBLegRight.png"
          );
        } else {
          setPath(
            "/images/imageCMFLegRight.png"
          );
        }
        break;
      case "PIE_IZQ":
        if (isBack) {
          setTitle("Diagnostico Pie Izquierdo");
          setAreaAfectada("Pie Izquierdo");
          setPath(
            "/images/imageCMBFootLeft.jpg"
          );
        } else {
          setTitle("Diagnostico Planta Izquierdo");
          setAreaAfectada("Planta Izquierdo");
          setPath(
            "/images/imageCMFFootLeft.jpg"
          );
        }
        break;
      case "PIE_DER":
        if (isBack) {
          setTitle("Diagnostico Pie Derecho");
          setAreaAfectada("Pie Derecho");
          setPath(
            "/images/imageCMBFootRight.jpg"
          );
        } else {
          setTitle("Diagnostico Planta Derecho");
          setAreaAfectada("Planta Derecho");
          setPath(
           "/images/imageCMFFootRight.jpg"
          );
        }
        break;
      default:
        setPath("");
        setTitle("Diagnostico");
        setAreaAfectada("");
    }
  };

  const handleSave = () => {
    ConfirmationAlert({
      title: "Registrar examen corporal",
      text: "¿Estas seguro de guardar los cambios?",
      onAccept: () => {
        let cuerpoObject =
          typeof visita.cuerpo === "string"
            ? JSON.parse(visita.cuerpo)
            : visita.cuerpo || {};

        const currentSide = cuerpoObject[sideKey] || {};
        const prevPartData = currentSide[part] || {};

        const draftsOfSide = draftPoints[sideKey] || [];
        const draftsOfThisPart  = draftsOfSide.filter(p => p.part === part);

        // const  newPoint = draftsOfThisPart.map(p => ({
        //   x: p.xPct ?? 0,
        //   y: p.yPct ?? 0,
        //   diametro: p.sizePct ?? 0.2,
        //   color: p.color || "#FF0000",
        // })); 

        const prevPuntos = Array.isArray(prevPartData.puntos) ? prevPartData.puntos : [];
        // const nextPuntos = [...prevPuntos, ...newPoint];
        let nextPuntos = [...prevPuntos];

        if (isEdit) {
          nextPuntos = prevPuntos.map((pp, i) => {
            const pid = pp.id || `${part}_${i}`;
            if (pid === originalPointKey) {
              return { ...pp, diagnostico: diagnostico };
            }
            return pp;
          });
        } else {
          const  newPoint = draftsOfThisPart.map(p => ({
            id: p.id,
            x: p.xPct ?? 0,
            y: p.yPct ?? 0,
            diametro: p.sizePct ?? 0.2,
            color: p.color || "#FF0000",
            diagnostico: diagnostico || "",
          })); 
          nextPuntos = [...prevPuntos, ...newPoint];
          
        }
        const newCuerpo = {
          ...cuerpoObject,
          [isBack ? "back" : "front"]: {
            ...currentSide,
            [part]: {
              ...prevPartData,
              code: prevPartData.code || code,
              area_afectada: areaAfectada || prevPartData.area_afectada || part,
              diagnostico: '',
              // diagnostico: diagnostico,
              puntos: nextPuntos,
            },
          },
        };
        
        const updatedVisita = {
          ...visita,
          cuerpo: JSON.stringify(newCuerpo), // Guardar como string para uniformidad
        };
        const newData = functions.dispatch(
          updateVisitasById(updatedVisita, visita.id)
        );
        
        // Actualiza la visita con el nuevo cuerpo
        if (newData?.error) {
          toast.error(`No se pudo crear el antecedente: ${newData.error}`);
        } else {
          setVisita(updatedVisita);
          const currentSideKey = isBack ? "back" : "front";
          if(isEdit) {
            updateSavedPoint?.(currentSideKey, part, originalPointKey, { diagnostico });
          } else {
            applySavedPoints?.(currentSideKey, part, [pendingPoint].map(p => ({ ...p, diagnostico })));
            setDraftPoints(prev => ({
              ...prev,
              [currentSideKey]: (prev[currentSideKey] || []).filter(p => p.part !== part),
            }));
          }

          toast.success("Examen guardado con exito!");
          closeModal();
        }
      },
    });

  };

  const handleDiagnosticoChange = (e) => {
    setDiagnostico(e.target.value);
  };

  return (
    <Modal
      closeModal={() => {
        onDeleteDraft?.(pendingPoint)
        closeModal(false)
      }}
      isOpen={isOpen}
      title={title}
      width={"min-w-3xl max-w-3xl"}
    >
      <div className={`flex ${view ? "flex-row" : "flex-col"} w-max-1/4`}>
        <div className="flex flex-col flex-1 w-full">
          {/* Form Fields */}
          <div className="mb-4">
            <label
              htmlFor="areaAfectada"
              className="block text-black text-sm mb-2"
            >
              Área afectada:
            </label>
            <input
              id="areaAfectada"
              type="text"
              disabled
              className="w-full text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain"
              value={
                areaAfectada  || ""
              }
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="diagnostico"
              className="block text-black text-sm mb-2"
            >
              Diagnóstico
            </label>
            <textarea
              id="diagnostico"
              className="w-full text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain h-32"
              value={diagnostico}
              // value={diagnostico || FrontBackBody[part]?.diagnostico || ""}
              onChange={handleDiagnosticoChange}
            />
          </div>

          {/* Action Buttons */}
          <div className="flex items-center gap-4 w-full">
            <div className="flex gap-4">
              <button
                className="flex items-center justify-center px-4 py-2 bg-subMain text-white rounded-md hover:bg-main transition"
                onClick={handleSave}
              >
                <FaSave className="mr-2" />
                Guardar
              </button>
              <button
                className="flex items-center justify-center px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition"
                onClick={() => {
                  onDeleteDraft?.(pendingPoint)
                  closeModal(false);
                }}
              >
                <FaTimesCircle className="mr-2" />
                Cancelar
              </button>
            </div>
            {isEdit && (
              <button
                className="ml-auto p-2 bg-transparent text-red-600 hover:text-red-700"
                title="Eliminar punto"
                aria-label="Eliminar punto"
                type="button"
                onClick={() => {
                  ConfirmationAlert({
                    title: "Eliminar punto",
                    text: "¿Deseas eliminar este punto?",
                    onAccept: () => {
                      let cuerpoObject =
                        typeof visita.cuerpo === "string"
                          ? JSON.parse(visita.cuerpo)
                          : visita.cuerpo || {};

                      const currentSide = cuerpoObject[sideKey] || {};
                      const prevPartData = currentSide[part] || {};
                      const prevPuntos = Array.isArray(prevPartData.puntos) ? prevPartData.puntos : [];

                      const filtered = prevPuntos.filter((pp, i) => {
                        const pid = pp.id || `${part}_${i}`;
                        return pid !== originalPointKey;
                      });

                      const newCuerpo = {
                        ...cuerpoObject,
                        [sideKey]: {
                          ...currentSide,
                          [part]: {
                            ...prevPartData,
                            puntos: filtered,
                          },
                        },
                      };

                      const updatedVisita = { ...visita, cuerpo: JSON.stringify(newCuerpo) };
                      const res = functions.dispatch(updateVisitasById(updatedVisita, visita.id));
                      if (res?.error) {
                        toast.error(`No se pudo eliminar: ${res.error}`);
                      } else {
                        setVisita(updatedVisita);
                        removeSavedPoint?.(sideKey, part, originalPointKey);
                        toast.success("Punto eliminado");
                      }
                      closeModal(false);
                    },
                  });
                }}
              >
                <FaTrashAlt className="w-5 h-5" />
              </button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};
